import { RootState } from '../../types';

export const getCreditBalanceSelector = (state: RootState): number =>
  state.balance.amount;

export const getInitialCreditAmountSelector = (state: RootState): number =>
  state.balance.initialAmount;
